import { API_AUTH } from "./common";

const GiaHanNoPhaiThuApi = {
  add: (
    dataSubmit = {
      ChoVayID: "",
      Time: "",
      Note: "",
      Value: "",
      TimeMustPay: "",
    }
  ) => API_AUTH.post(`nophaithu/luu-gia-han-no`, dataSubmit),
};

export default GiaHanNoPhaiThuApi;
